import { defaultField, defaultPercentField } from "helpers/row-logic-helper";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowAmortizationStartDate
  , shouldShowAmortization
  , shouldShowMonthlyPayment
  , shouldShowMonthlyPrincipalReduction
  , shouldShowAmortizationTerm
  , shouldShowAmortizationRate
  , shouldShowAmortizationTypeId
  , shouldShowInterestCalculation
  , shouldShowCalculationPeriods
  , shouldShowMisc
  , shouldShowPaymentDay
  , shouldShowBusinessDayAdjustment
} from "./section-amortization-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  amortization: {
    isVisible: loan => shouldShowAmortization(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Details",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: loan => defaultField(loan, "amortizationDetails.amortization"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  amortizationStartDate: {
    isVisible: loan => shouldShowAmortizationStartDate(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: loan => defaultField(loan, "amortizationDetails.amortizationStartDate"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  monthlyPayment: {
    isVisible: loan => shouldShowMonthlyPayment(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Monthly Payment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: loan => defaultField(loan, "details.currentPayment"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  monthlyPrincipalReduction: {
    isVisible: loan => shouldShowMonthlyPrincipalReduction(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Monthly Principal Reduction",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: loan => defaultField(loan, "amortizationDetails.monthlyPrincipalReduction"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  amortizationTerm: {
    isVisible: loan => shouldShowAmortizationTerm(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Term",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: loan => defaultField(loan, "amortizationDetails.amortizationTerm"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  amortizationRate: {
    isVisible: data => shouldShowAmortizationRate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Rate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: loan => defaultPercentField(loan, "amortizationDetails.amortizationRate", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },

  amortizationTypeId: {
    isVisible: loan => shouldShowAmortizationTypeId(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: loan => defaultField(loan, "amortizationDetails.amortizationType.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  paymentDays: {
    isVisible: data => shouldShowPaymentDay(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Days",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "details.paymentDay"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  businessDayAdj: {
    isVisible: data => shouldShowBusinessDayAdjustment(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Day Adj.",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "details.businessDayAdjustment.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  interestCalculation: {
    isVisible: loan => shouldShowInterestCalculation(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Interest Calculation",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: loan => defaultField(loan, "amortizationDetails.interestCalculation"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  calculationPeriods: {
    isVisible: loan => shouldShowCalculationPeriods(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Interest Only Periods",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: loan => defaultField(loan, "amortizationDetails.ioPeriod"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  misc: {
    isVisible: loan => shouldShowMisc(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Misc.",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: loan => defaultField(loan, "amortizationDetails.amortMisc"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
